export default contact => ({
  ...contact,
  metadata: Array.isArray(contact.metadata) ? {} : contact.metadata,
  organisations: {
    primary: contact.organisations.primary
      ? {
          id: contact.organisations.primary.id,
          version: contact.organisations.primary.version,
        }
      : null,
    secondary: (contact.organisations.secondary || []).map(organisation => ({
      id: organisation.id,
      version: organisation.version,
    })),
  },
  billing: {
    primary: contact.billing.primary ? contact.billing.primary.id : null,
    secondary: (contact.billing.secondary || []).map(billing => billing.id),
  },
  shipping: {
    primary: contact.shipping.primary ? contact.shipping.primary.id : null,
    secondary: (contact.shipping.secondary || []).map(shipping => shipping.id),
  },
  phone_numbers: {
    primary: contact.phone_numbers.primary ? contact.phone_numbers.primary.id : null,
    secondary: (contact.phone_numbers.secondary || []).map(phoneNumber => phoneNumber.id),
  },
});
